import React from 'react';

const Hero = () => {
  const handleConsultarClick = () => {
    const element = document.querySelector('#consulta-multas');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="position-relative py-5" style={{ minHeight: '500px', backgroundImage: `url(${process.env.PUBLIC_URL || ''}/images/autopista.png)`, backgroundSize: 'cover', backgroundPosition: 'right center' }}>
      {/* Overlay oscuro para mejor legibilidad del texto */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0.65)' }}></div>
      <div className="container position-relative" style={{ zIndex: 1 }}>
        <div className="row align-items-center" style={{ minHeight: '500px' }}>
          <div className="col-lg-6">
            <h1 className="display-4 fw-bold mb-3 text-white hero-fade-in hero-title">
              Gestionamos tus fotomultas para evitar antecedentes
            </h1>
            <h2 className="h3 mb-3 text-white hero-fade-in hero-subtitle">
              Tranquilidad y financiación para avanzar con seguridad en el futuro
            </h2>
            <p className="text-white-50 mb-4 small hero-fade-in hero-text">
              Conocé el estado jurídico de tus actas desde la comodidad de tu hogar u oficina
            </p>
            <button 
              className="btn btn-primary btn-lg px-5 py-3 hero-fade-in hero-button"
              onClick={handleConsultarClick}
            >
              Consultar Ahora
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

